import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, ProgressBar } from 'react-bootstrap';
import EmailForm from '../EmailForm';
import '../DocketPopup.less';
import * as docketActions from '../../../../../redux/actions/docketActions';

export function EmailPartModal(props) {
  useEffect(() => {
    if (props.selectedDocket.binder && props.selectedDocket.binder.documents) {
      const currentDocument = props.selectedDocket.binder.documents.find(
        document => document.number === props.popup.data.part_number
      );
      if (!currentDocument.download_url) {
        props.orderPdf(currentDocument, props.selectedDocket.docket_seq);
      }
    }
  }, []);

  const onSubmit = ({ emails, message }) => {
    const params = {
      email_address: emails.join(','),
      email_message: message,
    };
    props.onSendEmail(params);
  };

  const renderDownloadLink = () => {
    if (props.selectedDocket.binder && props.selectedDocket.binder.documents) {
      const currentDocument = props.selectedDocket.binder.documents.find(
        document => document.number === props.popup.data.part_number
      );
      if (currentDocument.filename && currentDocument.download_url) {
        return <a href={currentDocument.download_url}>{currentDocument.filename}</a>;
      }
    }
  };

  return (
    <Modal show onHide={props.onClose} backdrop="static" className="docket-popup">
      <Modal.Header closeButton>
        <Modal.Title>Email Part PDF</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EmailForm
          canSend
          onSendEmail={onSubmit}
          onCancel={props.onClose}
          sendButtonHint="Fill out destination address and any message and then click `Send`"
        >
          {
            <div className="docket-info-section">
              {props.popup.data.docket && (
                <div>
                  <span>
                    {`${props.popup.data.docket.date_filed} | ${props.popup.data.docket.docket_no} | ${props.popup.data.docket.docket_text}`}
                  </span>
                </div>
              )}
              <div className="docket-number-link">
                <a href={`/filings/${props.popup.data.case_uuid}`}>{props.popup.data.case_number}</a>
              </div>
            </div>
          }
          <label style={{ marginTop: '8px' }}>
            <i className="fa fa-paperclip" /> Attachment
          </label>
          <div className="bg-color-grey">
            {renderDownloadLink()}
            {props.popup.isEmailSending && (
              <div style={{ paddingTop: '15px' }}>
                <div>Sending...</div>
                <ProgressBar now={100} active />
              </div>
            )}
          </div>
        </EmailForm>
      </Modal.Body>
    </Modal>
  );
}

EmailPartModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSendEmail: PropTypes.func.isRequired,
  popup: PropTypes.object.isRequired,
  selectedDocket: PropTypes.object.isRequired,
  orderPdf: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const { popup, selectedDocket } = state.get('dockets').toJS();
  return {
    popup,
    selectedDocket,
  };
};

const mapDispatchToProps = {
  onSendEmail: docketActions.sendEmail,
  orderPdf: docketActions.orderPdf,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailPartModal);



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/EmailPartModal/EmailPartModal.jsx